import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from "../../../../toolkit/uicomponentcss";

export interface FlashMessageSubscriptionDetailsCSSStyle extends UIComponentCSSStyle
{
   
   
}

export class FlashMessageSubscriptionDetailsCSSStyleImpl extends UIComponentCSSStyleImpl implements FlashMessageSubscriptionDetailsCSSStyle
{

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessagesubscriptiondetails/flashmessagesubscriptiondetailscss.tsx